<template>
  <div class="course-select-dialog">
    <el-dialog
      v-if="dialogVisible"
      :title="DialogTitle"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <!-- <el-input placeholder="请输入内容" style="width: 372px;margin-bottom: 18px;" ></el-input> -->
      <!-- {{ type }}
      <br /><br />
      <div>
        [1, 3, 6, 7] 》缓修，缓考、免修不免考、免修免考 》 无成绩<br />
        <br />

        [2, 4, 5] 》 再考、缓修再修、重修 》 有成绩<br />
        重修：课程情况：历史课程中成绩不合格的课程<br />
        缓修再修：提交缓修通过的课程<br /><br />
      </div> -->
      <el-form ref="ruleForm" :inline="true" :model="formInline" size="small">
        <el-form-item label="课程名称" prop="keyword">
          <el-input v-model="formInline.keyword" placeholder="请输入课程名称" clearable />
        </el-form-item>
        <el-form-item label="学年" prop="schoolYearId">
          <el-select v-model="formInline.schoolYearId" clearable placeholder="请选择学年" @change="getSchoolYearSemesters()">
            <el-option v-for="item in schoolYearLists" :key="item.id" :label="item.title.title" :value="item.title.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="学期" prop="semesterId">
          <el-select v-model="formInline.semesterId" clearable :placeholder="formInline.schoolYear ? '请选择学期' : '请先选择学年'" :disabled="!formInline.schoolYearId">
            <el-option v-for="item in yearSemesters" :key="item.id" :label="item.title" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="onSubmit">搜索</el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <ming-table v-if="dialogVisible" v-loading="isLoading" :fields="column" :data="data" :is-select-current-row="true" max-height="500px">
        <!-- 考试安排 -->
        <template #examSchedule="{ scope }">
          <el-button v-if="+scope.hasExam === 1" type="text" @click="getExamInfo(scope.ctId)">查看</el-button>
          <span v-else>-</span>
        </template>
        <!-- 课程安排 -->
        <template #courseSchedule="{ scope }">
          <el-button type="text" @click="getCourseDialog(scope.ctId)">查看</el-button>
        </template>

        <template #select-radio="{ scope }">
          <el-checkbox v-model="scope.icCheck" @change="selectChange(scope)"></el-checkbox>
        </template>
        <!-- getCourseDialog -->
      </ming-table>
      <course-time-dialog v-if="CourseTimeVisible" :visible.sync="CourseTimeVisible" type="courseTime" :teacher-data="[]" :course-id="CourseID" />
      <exam-info-dialog v-if="examInfoVisible" :visible.sync="examInfoVisible" :course-id="CourseID" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, reactive } from 'vue'
import API from '@/api'
import ExamInfoDialog from './ExamInfoDialog.vue'
import courseTimeDialog from './CourseTimeDialog.vue'
import Store from '@/store'

const isLoading = ref(false)
// 学年下拉数据
const schoolYearLists = computed(() => {
  return Store.state.common.UserPortalData.schoolYearLists
})

const yearSemesters = ref([])
// 获取学期
const getSchoolYearSemesters = () => {
  yearSemesters.value = []
  API.schoolYearSemesters({ schoolYear: formInline.schoolYearId }).then(res => {
    if (res.code === 200) {
      yearSemesters.value = res.data
    }
  })
}
const ruleForm = ref(null)
const reset = () => {
  ruleForm.value.resetFields()
  getCourseData()
}
const onSubmit = () => {
  getCourseData(formInline)
}
const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false
  },
  type: {
    type: Number,
    default: 0
  },
  // eslint-disable-next-line vue/prop-name-casing
  cb_id: {
    type: Number,
    default: 0
  }
})
const formInline = reactive({ schoolYearId: '', semesterId: '', keyword: '' })

function selectChange(row) {
  row.icCheck = !row.icCheck
  let newData = []
  newData = data.value.map(ele => {
    if (ele.ctId === row.ctId) {
      row.icCheck = true
      currCheck.value = row
    } else {
      ele.icCheck = false
    }
    return ele
  })
  data.value = newData
}
// 查看考试安排
const examInfoVisible = ref(false)
const CourseID = ref()
function getExamInfo(id) {
  CourseID.value = id
  examInfoVisible.value = true
}

const CourseTimeVisible = ref(false)

// 打开课程弹窗
function getCourseDialog(id) {
  CourseTimeVisible.value = true
  CourseID.value = id
}

const currCheck = ref({})

const data = ref([])

const emit = defineEmits(['handleClose', 'checkSubmit'])

const DialogTitle = ref('目标课程')
const dialogVisible = computed(() => {
  return props.visible
})

function getCourseData(params) {
  isLoading.value = true
  const defaultParams = {
    page: 1,
    pageSize: 1000,
    courseChangeType: props.type,
    cb_id: props.cb_id,
    ...params
  }
  API.MBACourseByType(defaultParams).then(res => {
    isLoading.value = false
    const formatData = res.data.lists || []
    formatData.forEach(ele => {
      ele.icCheck = false
    })
    data.value = formatData
  })
}

function handleClose() {
  emit('update:visible', false)
}

function submit() {
  emit('checkSubmit', currCheck)
}
// table fileds
const column = ref()
onMounted(() => {
  Store.dispatch('common/UserPortalData')
  // getSchoolYearSemesters()
  getCourseData()
  column.value = []
  const defaultColumn = [
    {
      label: '课程编号',
      field: 'code'
    },
    {
      label: '课程名称',
      field: 'name',
      minWidth: '200px'
    },
    {
      label: '课程性质',
      field: 'nature',
      minWidth: '100px'
    },
    {
      label: '学年',
      field: 'schoolYear',
      minWidth: '120px'
    },
    {
      label: '学期',
      field: 'semester'
    },
    {
      label: '授课班级',
      field: 'class'
    }
  ]

  switch (Number(props.type)) {
    case 2:
      column.value = defaultColumn.concat([
        {
          label: '授课老师',
          field: 'teacher',
          width: '100px'
        },
        {
          label: '课程安排',
          field: 'courseSchedule',
          width: '100px',
          slot: true
        },
        {
          label: '选择',
          field: 'select-radio',
          width: '60px',
          slot: true
        }
      ])
      break
    case 5:
      column.value = defaultColumn.concat([
        {
          label: '课程安排',
          field: 'courseSchedule',
          width: '100px',
          slot: true
        },
        {
          label: '选择',
          field: 'select-radio',
          width: '60px',
          slot: true
        }
      ])
      break
    case 4:
      column.value = defaultColumn.concat([
        {
          label: '考试安排',
          field: 'examSchedule',
          width: '100px',
          slot: true
        },
        {
          label: '选择',
          field: 'select-radio',
          width: '60px',
          slot: true
        }
      ])
      break
    default:
      column.value = defaultColumn.concat([
        {
          label: '选择',
          field: 'select-radio',
          width: '60px',
          slot: true
        }
      ])
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
}

:deep(.el-dialog__footer) {
  border-top: 1px solid rgba(0, 0, 0, 0.09);
}

:deep(.el-dialog__body) {
  padding-top: 16px;
}
:deep(.dialog-fade-leave-active) {
  animation: none !important;
}
</style>
